module.exports = __webpack_public_path__ + "img/paw-square-5bc1389.png";